<div *ngIf="planTerms.length">
<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">

  <!-- Choose Plan Type -->
  <div class="mb-4 col-12">
    <label class="form-label">Choose {{brandDetails.features.membership_label_text || "Membership"}} Type <span class="text-danger">*</span></label>
    <div class="row">
      <div class="mb-5 col-6 col-md-4" *ngFor="let option of planTypes; let i = index">
        <label class="btn btn-outline btn-outline-dashed d-flex flex-stack text-start p-3 bg-white">
          <div class="d-flex align-items-center me-1">
            <div class="form-check form-check-custom form-check-solid form-check-primary me-2">
              <input class="form-check-input" type="radio" formControlName="planType" [value]="option.type" [checked]="i === 0" />
            </div>
            <div class="flex-grow-1">
              <h2 class="d-flex align-items-center fs-6 fw-normal flex-wrap pt-2">
                {{ option.value }}
              </h2>
            </div>
          </div>
          <i class="bi bi-info-circle ms-2" data-bs-placement="right" [ngbTooltip]="option.raw?.description || 'No description available.'" *ngIf="option.raw?.description"></i>

          </label>
      </div>
    </div>
    <span class="invalid-feedback d-block"
      *ngIf="formGroup.get('planType')?.hasError('required') && formGroup.get('planType')?.touched">
      This field is required
    </span>
  </div>

  <!-- Choose Term -->
  <div class="mb-4 col-12">
    <label class="form-label">Choose Term <span class="text-danger">*</span></label>
    <div class="row">
      <div class="mb-5 col-6 col-md-4" *ngFor="let option of planTerms; let i = index">
        <label class="btn btn-outline btn-outline-dashed d-flex flex-stack text-start p-3 bg-white">
          <div class="d-flex align-items-center me-2">
            <div class="form-check form-check-custom form-check-solid form-check-primary me-2">
              <input class="form-check-input" type="radio" formControlName="planTerm" [value]="option.type"
                [checked]="i === 0" />
            </div>
            <div class="flex-grow-1">
              <h2 class="d-flex align-items-center fs-6 fw-normal flex-wrap pt-2">
                {{ option.label | titlecase }} ({{currency}} {{ option.price }})
              </h2>
            </div>
          </div>
        </label>
      </div>
    </div>
    <span class="invalid-feedback d-block"
      *ngIf="formGroup.get('planTerm')?.hasError('required') && formGroup.get('planTerm')?.touched">
      This field is required
    </span>
  </div>
  <div class="text-center mt-5">
    <ng-container>
      <div class="text-center text-muted">
        <p>A payment of  <strong class="text-primary">{{currency}} {{selectedPlanPrice}}/-</strong> is required to subscribe to this {{(brandDetails.features.membership_label_text || "Membership") |lowercase}}.</p>
         <p>Please click the button below to make payment.</p>
      </div>
      <button type="submit" class="btn btn-lg btn-theme text-white ls-2 text-uppercase fw-boldest">
        Make Payment
      </button>
    </ng-container>
  </div>

</form>
</div>
<div *ngIf="!planTerms.length" class="card mb-5 mb-xl-8">
  <div class="card-body py-10 text-center">
    <div class="symbol symbol-60px mb-4">
      <span class="symbol-label bg-light-warning">
        <i class="bi bi-exclamation-circle text-warning fs-2x"></i>
      </span>
    </div>
    <h4 class="fw-bold text-dark mb-2">No {{(brandDetails.features.membership_label_text || "Membership") |lowercase}} Available</h4>
    <p class="text-muted mb-0">
      Your account is subscribed to a higher plan. Lower-tier plans are not available.
    </p>
  </div>
</div>

